<template>
  <div class="calico-page-select-card">
    <h1>Calico Select Cards</h1>
    <div class="container">
      <div class="div">
        <SelectCard
          v-model="groupValue"
          value="card1"
          title="Custom Title"
          description="This is a custom description for card 1."
        />
        <SelectCard
          v-model="groupValue"
          value="card2"
          title="Custom Title"
          description="This is a custom description for card 2."
        />
        <SelectCard
          v-model="groupValue"
          value="card3"
          title="Custom Title"
          description="This is a custom description for card 3."
        />
        <SelectCard
          v-model="groupValue"
          value="card4"
          :disabled="true"
          title="Custom Title"
          description="This is a custom description for card 4."
        />
      </div>
    </div>
  </div>
</template>

<script>
import SelectCard from '@/components/calico/selectCard';

export default {
  name: 'CalicoSelectCardView',
  components: {
    SelectCard,
  },
  data() {
    return {
      groupValue: null,
    };
  },
};
</script>

<style scoped lang="scss">
.calico-page-select-card {
  margin: 30px;

  .div {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 20px;
  }
}
</style>